// extracted by mini-css-extract-plugin
module.exports = {"rememberMe":"rememberMe-2kdZn","rememberMeIsActive":"rememberMeIsActive-27_M3","rememberMeLabel":"rememberMeLabel-1jda3"};